export class Step1 {
	public intitule = 'stepper.form.simp_in.step1';

	public getoui = 'form.simp_in.getoui';
	public getnon = 'form.simp_in.getnon';
	public getspan1 = 'form.simp_in.getspan1';
	public getspan2 = 'form.simp_in.getspan2';
	public getspan3 = 'form.simp_in.getspan3';
	public getspan4 = 'form.simp_in.getspan4';
	public getspan5 = 'form.simp_in.getspan5';
	public getspan6 = 'form.simp_in.getspan6';

	public urlProfilAch = 'form.simp_in.geturlprofilach';
	public urlDocConsul = 'form.simp_in.geturldocconsul';
	public autre = 'form.simp_in.getautre';
	public identifiantInterne = 'form.simp_in.getidentifiantinterne';
	public mesuresConfidentialite = 'form.simp_in.getmesuresconfidentialite';
	public mesuresConfurlConfidentialite = 'form.simp_in.getmesuresconfurlconfidentialite';
	public nomContact = 'form.simp_in.getnomcontact';
	public adresseMailContact = 'form.simp_in.getadressemailcontact';
	public telContact = 'form.simp_in.gettelcontact';

	constructor() {}
}
